/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  // 生成随机时间
  function generateRandomTime() {
    var hours = Math.floor(Math.random() * 15) + 1
    var minutes = Math.floor(Math.random() * 60)
    var seconds = Math.floor(Math.random() * 60)
    //总共的毫秒数
    var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

    return targetTime
  }
  function TimeDown(value) {
    //倒计时的总秒数
    var totalSeconds = parseInt(value / 1000)
    //取模（余数）
    var modulo = totalSeconds % (60 * 60 * 24)
    //小时数
    var hours = Math.floor(modulo / (60 * 60))
    modulo = modulo % (60 * 60)
    //分钟
    var minutes = Math.floor(modulo / 60)
    //秒
    var seconds = modulo % 60

    hours = hours.toString().length == 1 ? '0' + hours : hours
    minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

    //输出到页面
    $('.sp_hour').html(hours)
    $('.sp_minute').html(minutes)
    $('.sp_second').html(seconds)
    //延迟一秒执行自己
    if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
    } else {
      setTimeout(function () {
        TimeDown(value - 1000)
      }, 1000)
    }
  }
  TimeDown(generateRandomTime())
  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img1.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img2.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img3.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img4.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img1-pc.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img2-pc.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img3-pc.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-part1-img4-pc.png",

    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-before1.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-before2.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-before3.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-after1.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-after2.png",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-after3.png",
  ];

  new Swiper(".sp-swiper-fade", {
    // spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });
  new Swiper(".sp-swiper-fade2", {
    slidesPerView: 1.5,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper-scroll1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
  });
  new Swiper(".sp-swiper-scroll2", {
    slidesPerView: 1.8,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 5500, //匀速时间
    autoplay: {
      delay: 3000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  });
  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });
  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    loop: true,
  });
  $(".product-box .sp-opt").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let _index = $(this).index();

    $(this)
      .parents(".product-box")
      .find(".sp-p-img")
      .eq([_index])
      .show()
      .siblings(".sp-p-img")
      .hide();
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
        config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        console.log(offsetTop)
        let sptop = document.body.clientWidth <= 1080 ? $('.sp-mobile .sp-fixed-top').height() : $('.sp-pc .sp-fixed-top').height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // 找到所有跳转绑品的锚点链接
    var bindsLinks = document.querySelectorAll('a[href^="#binds"]');
    bindsLinks.forEach(function (bindsLink) {
      bindsLink.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("binds"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        console.log(offsetTop)
        let sptop = document.body.clientWidth <= 1080 ? $('.sp-scroll-top .sp-mobile').height() : $('sp-scroll-top .sp-pc').height();
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            200 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let sp_price1 = 9.99;
  let sp_price2 = 19.89;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  $(".sp-mobile .reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#new").html(calcTotal(sp_price1, input.value));
    $("#old").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-mobile .add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#new").html(calcTotal(sp_price1, input.value));
    $("#old").html(calcTotal(sp_price2, input.value));
  });

  $(".sp-pc .reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#sp_price3").html(calcTotal(sp_price1, input.value));
    $("#sp_price4").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-pc .add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price3").html(calcTotal(sp_price1, input.value));
    $("#sp_price4").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-pc .product-box").click(function () {
    $(this).addClass("sp-active").siblings().removeClass("sp-active");
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
  var imgArr = [
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-1.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-2.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color2.png',
        "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/3_5e22b82c-3168-4064-9ac9-3440927feb3e.png?v=1765357442",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/5_6677b36b-f2ff-4c40-9deb-2df29d64ed77.png?v=1765357442",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/8.png?v=1765357442",
   
     "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/1_5aac5d3c-e26d-4761-9ee9-efbb906c72ae.png?v=1764750271",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/3_abdc0d70-2b27-4f2d-9f38-bf067b7f1b4f.png?v=1764750271",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/5_d6ab5b2a-dcff-4678-b026-29e42a6d42fb.png?v=1764750271",
    'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/2_761629ba-f12b-48cb-9a08-9546cac0cb72.png?v=1764750276',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-4.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color3.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-4.png',
    'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/4_c9a25809-ef89-4dfc-a25e-a12646fda76a.png?v=1764750277',
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/6_736298a2-2475-49d9-9715-5eb5f5e6dc4b.png?v=1764750277",

    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-6.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color4.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-6.png',
  ]
  var imgArrpc = [
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-1-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-2-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color2-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-3-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-4-pc.png',
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/3_e5793148-afa4-4c4b-a6f1-3dd0b8805c94.png?v=1765357606",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/5_a769f180-fefa-48d5-9041-9b3f3549b4a0.png?v=1765357606",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/8_bdd7f5c8-87d2-4d15-bf68-c21d5e30c822.png?v=1765357606",
       "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/1_c7f85d89-993b-47a6-9d70-1eb533be0888.png?v=1764750201",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/3_8c46ecba-dade-4996-9c30-66ec682e65bb.png?v=1764750201",
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/5_3751101c-a1f3-494b-a25c-dd5801f48826.png?v=1764750201",
    'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/2_75f3d71e-ac50-4012-b2d1-a6cf40255fc2.png?v=1764750254',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-4-pc.png',
    'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/4.png?v=1764750257',
    "https://cdn.shopify.com/s/files/1/0709/5756/4090/files/6.png?v=1764750256",
 
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-6-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-color4-pc.png',
    // 'https://cdn.shopify.com/s/files/1/0709/5756/4090/files/20251029-pro-6-pc.png',
  ]
  // 产品切换
  $('.opt-group .option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
  })
  $('#color .option').click(function () {
    var index = $(this).index()
    var index2 = $('#Size .option.active').index()
    const parentBox = $(this).parents('.product-part')
    changeoption(index, index2, parentBox)
  })
  $('#color2 .option').click(function () {
    var index = $(this).index()
    var index2 = $('#Size2 .option.active').index()
    const parentBox = $(this).parents('.product-part')
    changeoption(index, index2, parentBox)
  })
  $('#Size .option').click(function () {
    var index = $('#color .option.active').index()
    var index2 = $(this).index()
    const parentBox = $(this).parents('.product-part')
    changeoption(index, index2, parentBox)
  })
  $('#Size2 .option').click(function () {
    var index = $('#color2 .option.active').index()
    var index2 = $(this).index()
    const parentBox = $(this).parents('.product-part')
    changeoption(index, index2, parentBox)
  })
  function changeoption(index, index2, parentBox) {
    $('.sp-mobile .top-product>img').attr('src', imgArr[index * 3 + index2])
      $('.sp-pc .top-product>img').attr('src', imgArrpc[index * 3 + index2])
    // if (index2 == 0) {
    //   $('.sp-mobile .top-product>img').attr('src', imgArr[index])
    //   $('.sp-pc .top-product>img').attr('src', imgArrpc[index])
    // } else if (index2 == 1) {
    //   $('.sp-mobile .top-product>img').attr('src', imgArr[index + 4])
    //   $('.sp-pc .top-product>img').attr('src', imgArrpc[index + 4])
    //   $('.sp-pro-only').html('only $6.66/pc')
    // } else if (index2 == 2) {
    //   $('.sp-mobile .top-product>img').attr('src', imgArr[index + 8])
    //   $('.sp-pc .top-product>img').attr('src', imgArrpc[index + 8])
    //   $('.sp-pro-only').html('only $5.99/pc')
    // }
    // if (index == 2 && index2 == 1 || index == 0 && index2 == 1 || index == 0 && index2 == 2 || index == 2 && index2 == 2) {
    //   $('.sp-pro-only').show()
    // } else {
    //   $('.sp-pro-only').hide()
    // }
    
    changePrice(parentBox)
  }

  let prods = window.product
  function getCur(parentBox) {
    let color = parentBox.find('#color div.active').attr('data-val') || parentBox.find('#color2 div.active').attr('data-val')
    let size = parentBox.find('#Size div.active').attr('data-val') || parentBox.find('#Size2 div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == size)[0]
  }
  function changePrice(parentBox) {
    let num = parentBox.find('#calcNumber').val()
    let price = ((getCur(parentBox).price * num) / 100).toFixed(2)
    let compare = ((getCur(parentBox).compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    parentBox.find('.price1 span').html(price)
    parentBox.find('.price2 span').html(compare)
    
    let off_font = 100 - Math.ceil((getCur(parentBox).price / getCur(parentBox).compare_at_price) * 100);
    parentBox.find('.sp-frees span span').html(off_font)
    // let off_price = (
    //   (getCur().compare_at_price - getCur().price) /
    //   100
    // ).toFixed(2)
    // off_price = (off_price + '').replace('.', ',')
    // $('.product-part .price-group .price3 span').html(off_price)
  }
  $('.sp-btn-style').click(function () {
    const parentBox = $(this).parents('.product-part')
    let num = parentBox.find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(parentBox).id + ':' + num
  })

  function checkDeviceType() {
    const isMobile = window.matchMedia("(max-width: 1080px)").matches;
    return isMobile ? true : false
  }
  // 加入购物车
  addCart()
  function addCart() {
    // 加入购物车
    $('.addCerts').click(function () {
      // do something here
      var number =
        Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
      $('.sp-cart #cardNum').html(number)
      if (number > 0) {
        $('.sp-cart .num').css('background', '#cf0101')
      } else {
        $('.sp-cart .num').css('background', '#919191')
      }
      var img = $('.top-product img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.product-part').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.sp-cart').addClass('shake')
      setTimeout(() => {
        $('.sp-cart').removeClass('shake')
      }, 1000)
      var finish
      if (checkDeviceType()) {
        finish = $('.sp-cart')[0]
      } else {
        finish = $('.sp-cart')[1]
      }
      $('.clone').animate(
        {
          top: finish.offsetTop,
          left: finish.offsetLeft + $('.sp-cart').width() / 2 - 15,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });
  // // 关闭弹窗按钮

  // $(".sp-mask").click(function (e) {
  //   if ($(e.target).closest(".sp-mask video").length > 0) {
  //   } else {
  //     $(".sp-mask").hide();
  //   }
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $(".sp-header").height() * $("div#root").css("zoom")
  ) {
    $(".sp-fixed-top").addClass("sp-fixed");
  } else {
    $(".sp-fixed-top").removeClass("sp-fixed");
  }

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $(".sp-header").height() * $("div#root").css("zoom")
    ) {
      $(".sp-fixed-top").addClass("sp-fixed");
    } else {
      $(".sp-fixed-top").removeClass("sp-fixed");
    }
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");

  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
